import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    alignItems: 'center',
  },
  containerGrid: {
    maxWidth: 430,
    backgroundColor: theme.palette.background.paper,
    padding: '56px 40px 54px 40px',
    borderRadius: 8,
    margin: '101px 0 80px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      margin: 0,
      padding: '56px 21px 92px',
      borderRadius: '0px',
    },
  },
  titulo: {
    color: theme.screens.esqueciSenhaEmail.title,
    fontFamily: 'BancoDoBrasilTitulos',
    fontSize: '24px',
    lineHeight: '32px',
    maxWidth: '325px',
    textAlign: 'left',
    marginBottom: '25px',
    fontWeight: 700,
  },
  subTitulo: {
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    fontSize: '14px',
    letterSpacing: '-0.01px',
    lineHeight: '24px',
    width: '335px',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  imagemEsqueciMinhaSenha: {
    width: '139px',
    height: '130px',
    marginLeft: '-27px',
    [theme.breakpoints.down('xs')]: {
      width: '120px',
      height: '109px',
    },
  },
}));
